/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import './sitemap/s-sitemap';
import './newsletter-signup/s-newsletter-signup';
import './notification/s-notification';
import './quick-donate/s-quick-donate';
import './donation-header/s-donation-form-multi-step';
import './donation-form-layout-multi-step/s-donation-form';
import './donation-header/fz';



// WEBPACK FOOTER //
// ./src/sections/sections.js